import React from 'react';
import { Spin } from 'antd';
import './Display.css';
import { useImages } from '../hooks/useImages';
import { getImageUrl } from '../utils/imageUtils';

const Display: React.FC = () => {
  // 从后台获取产品展示图片数据
  const { images, loading, error } = useImages('product_showcase');

  // 如果正在加载，显示加载状态
  if (loading) {
    return (
      <section className="display" id="display">
        <div className="container">
          <div className="display-header">
            <h2 className="display-title">解郁大药房产品展示</h2>
            <p className="display-subtitle">专业医药产品，品质保证</p>
          </div>
          <div className="display-loading">
            <Spin size="large" />
            <p>加载产品展示中...</p>
          </div>
        </div>
      </section>
    );
  }

  // 如果有错误，显示错误信息
  if (error) {
    return (
      <section className="display" id="display">
        <div className="container">
          <div className="display-header">
            <h2 className="display-title">解郁大药房产品展示</h2>
            <p className="display-subtitle">专业医药产品，品质保证</p>
          </div>
          <div className="display-error">
            <p>{error}</p>
          </div>
        </div>
      </section>
    );
  }

  // 过滤并排序图片
  const displayImages = images
    .filter(img => img.isActive)
    .sort((a, b) => a.position - b.position)
    .map((img) => ({
      src: getImageUrl(img._id),
      alt: img.alt || img.originalName
    }));

  return (
    <section className="display" id="product-center">
      <div className="container">
        <div className="display-header">
          <h2 className="display-title">解郁大药房产品展示</h2>
          <p className="display-subtitle">专业医药产品，品质保证</p>
        </div>
        {displayImages.length > 0 ? (
          <div className="display-grid">
            {displayImages.map((image, index) => (
              <div key={index} className="display-item">
                <img 
                  src={image.src} 
                  alt={image.alt}
                  className="display-image"
                />
              </div>
            ))}
          </div>
        ) : (
          <div className="display-empty">
            <p>暂无产品展示数据</p>
          </div>
        )}
      </div>
    </section>
  );
};

export default Display; 